import './App.css';
import { MyChart } from './components/MyChart';

function App() {
  return (
    <div className="App">
        <MyChart />
    </div>
  );
}

export default App;
